export default {
  stats: {
    orders: 'Encomendas',
    sales: 'Receita',
  },
};
